/**
 * Query Key factory for all slot template queries.
 *
 * @module SlotTemplate
 */

import { Pagination } from "@customTypes/index";


export const slotTemplateQKeys = {
  all: () => ["slotTemplates"] as const,

  allWithFilters: (filters?: {
    doctorAssigned?: string;
    isActive?: boolean;
    pagination?: Partial<Pagination>;
  }) => [...slotTemplateQKeys.all(), { ...filters }] as const,

  detail: (templateId: string) =>
    [...slotTemplateQKeys.all(), templateId] as const,

  exceptions: (templateId: string) =>
    [...slotTemplateQKeys.detail(templateId), "exceptions"] as const,

  schedulerStatus: () => ["schedulerStatus"] as const,
};
